(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/game-package/assets/javascripts/pay/draw-closed-dialog.js') >= 0) return;  svs.modules.push('/modules/game-package/assets/javascripts/pay/draw-closed-dialog.js');

'use strict';

const productMapping = svs.numbergames.productMapping;
function drawClosedDialog(_ref) {
  let next = _ref.next,
    cancel = _ref.cancel,
    closedProductItsIds = _ref.closedProductItsIds,
    draws = _ref.draws;
  const closedProducts = closedProductItsIds.map(productItsId => productMapping.getProductDayName(productItsId));
  const closedDailyProducts = closedProducts.filter(product => productMapping.isDaily(product));
  const closedWeeklyProducts = closedProducts.filter(product => !productMapping.isDaily(product));
  const texts = [];
  if (closedDailyProducts.length) {
    closedDailyProducts.forEach(product => {
      const draw = draws.find(d => productMapping.isSameProduct(d.productItsId, product));
      const day = svs.utils.date.FormatTime('EEEE', draw.regCloseTime);
      texts.push("Tiden f\xF6r spelstopp hann passera f\xF6r dagens dragning p\xE5 ".concat(product, ". Du spelar ist\xE4llet p\xE5 dragningen p\xE5 ").concat(day, "."));
    });
  }
  if (closedWeeklyProducts.length) {
    texts.push("Tiden f\xF6r spelstopp hann passera f\xF6r dagens dragning p\xE5 ".concat(closedWeeklyProducts.join(' och '), ". Du spelar ist\xE4llet p\xE5 dragningen n\xE4sta vecka."));
  }
  svs.ui.dialog.api.add(new svs.ui.dialog.Confirm({
    branding: svs.ui.dialog.branding.TUR,
    type: svs.ui.dialog.type.INFO,
    icon: 'exclamation-sign',
    title: "Spelstopp p\xE5 ".concat(closedProducts.join(' och '), "!"),
    message: [{
      type: svs.ui.dialog.message.TEXT,
      align: svs.ui.dialog.message.align.CENTER,
      text: texts.join(' ')
    }],
    actions: [{
      title: 'Avbryt',
      callback: (e, forms, dialog) => {
        dialog.close();
        cancel();
      }
    }, {
      title: 'Betala',
      callback: (e, forms, dialog) => {
        dialog.close();
        next();
      }
    }]
  }));
}
svs.gamePackage.pay.drawClosedDialog = drawClosedDialog;

 })(window);